import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseModal } from '../modals/base_modal.component';
import { Input } from '../inputs/input.component';
import { Button } from '../inputs/button.component';

interface CreateFolderModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: ( name: string ) => void;
}

export function CreateFolderModal( { isOpen, isLoading, onClose, onConfirm }: CreateFolderModalProps ) {
  const { t } = useTranslation();
  const [ name, setName ] = useState( '' );

  const handleClose = () => {
    setName( '' );
    onClose();
  };

  const handleConfirm = () => {
    if ( name.trim() === '' ) { return; }
    onConfirm( name.trim() );
    setName( '' );
  };

  return (
    <BaseModal
      title={ t( 'translation:create_folder' ) }
      isOpen={ isOpen }
      onClose={ handleClose }
      iconColor="#ef4444"
    >
      <div className="flex flex-col gap-4 p-4">
        <Input
          value={ name }
          label={ t( 'translation:folder_name' ) }
          placeholder={ t( 'translation:my_folder' ) }
          required
          disabled={ isLoading }
          onChange={ val => { setName( val ); } }
          onKeyEnterUp={ () => { handleConfirm(); } }
        />
        <div className="flex justify-end gap-2">
          <Button
            label={ t( 'translation:cancel' ) }
            color="#6b7280"
            colorHover="#4b5563"
            disable={ isLoading }
            onClick={ handleClose }
          />
          <Button
            label={ isLoading ? t( 'translation:creating' ) : t( 'translation:create' ) }
            color="#ef4444"
            colorHover="#dc2626"
            disable={ name.trim() === '' || isLoading }
            onClick={ handleConfirm }
          />
        </div>
      </div>
    </BaseModal>
  );
}
